import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'air-skeleton-card',
  templateUrl: './skeleton-card.component.html',
  imports: [NgClass, TranslatePipe]
})
export class SkeletonCardComponent {
  @Input() isLarge: boolean;
  @Input() hasText = true;
  @Input() additionalClasses: any;
}
